import { useMutation, useQueryClient } from '@tanstack/react-query';
import { refreshMyComplianceStatus } from '../../../services/MoodleService';
import { moodleQueryKeys } from '../all-query-keys';

export const useRefreshMyStatus = (onSuccess) => {
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationFn: refreshMyComplianceStatus,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: moodleQueryKeys.courseCompletionReports(),
      });
      queryClient.invalidateQueries({
        queryKey: moodleQueryKeys.getMyBlockingDecision(),
      });
      onSuccess?.(...args);
    },
  });

  return { mutate, isPending };
};
